class CartAddButton extends HTMLElement {
  connectedCallback () {
		const button = this.querySelector('button');
		const buttonLabel = button.querySelector('span');

		const soldOutText = button.dataset.soldOutText || 'Sold Out';
		const addToCartText = button.dataset.addToCart || 'Add to Cart';
		const addedToCartText = button.dataset.addedToCart || 'Added!';
		const loadingText = button.dataset.loading || 'Adding...';

		button.addEventListener('click', async (el) => {
			if (button.disabled) {
				return;
			}

			button.disabled = true;
			buttonLabel.textContent = loadingText;

			const { variantId } = el.target.dataset;

			try {
				await window.panagoraTheme.addItem(parseInt(variantId, 10), {
					quantity: 1,
					properties: this.getCartProperties(),
				});

				const instances = window.panagoraTheme.getInstances('cart');

				instances[0]?.getCart().then(() => {
					document.querySelector('[data-target="cart"]').click();
				});

				buttonLabel.textContent = addedToCartText;

				setTimeout(() => {
					buttonLabel.textContent = addToCartText;
					button.disabled = false;
				}, 1000);
			} catch (err) {
				console.error(err.message);
				buttonLabel.textContent = err.message.includes('Sold Out')
					? soldOutText
					: err.message;
				button.disabled = false;
			}
		});
  }

  getCartProperties() {
    const properties = {};

    // Check for data-properties attribute (JSON string)
    const propertiesData = this.querySelector('script[data-properties]')?.textContent;
    if (propertiesData) {
      try {
        Object.assign(properties, JSON.parse(propertiesData));
      } catch (e) {
        console.warn('Invalid properties JSON:', propertiesData);
      }
    }

    return properties;
  }
}

customElements.define( 'cart-add-button', CartAddButton );
